export default {"src":"/_next/static/media/our-services-visa.ba5aa68f.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};